import { postFetch } from '../fetch';
import { apiConfig } from '../config';

export function postCopyCLesson(
    cLessonId: string | number,
    newLessonName: string,
    classIds: unknown[],
    { creationType, replaceProblems }: { creationType?: string, replaceProblems?: boolean } = {}
) {
    const { apiPostCopyCLesson } = apiConfig.getStaticUrls();

    return postFetch(apiPostCopyCLesson, {
        cLessonId,
        newLessonName,
        classIds,
        creationType,
        replaceProblems,
    });
}
